import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import AdminNavbar from "../../components/partial/AdminNavbar";
import {
  addAlumni,
  getAlumniData,
  deleteAlumniData,
  updateAlumniData,
} from "../../store/alumni/reducer";
import { useDispatch, useSelector } from "react-redux";
import { AiOutlineDelete } from "react-icons/ai";
import { FaRegEdit } from "react-icons/fa";
import Button from "../../components/common/Button";
import { Toaster, toast } from "sonner";
const Alumni = () => {
  const rawAlumni = useSelector((state) => state.alumniReducer.alumniData);
  const alumniData = (rawAlumni && rawAlumni.data) || [];
  console.log("[Alumni] rawAlumni:", rawAlumni);
  console.log("[Alumni] alumniData array:", alumniData);
  const dispatch = useDispatch();

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset, // For resetting the form
    setValue, // For setting form values
  } = useForm();

  const [photos, setPhotos] = useState([]); // Store new images
  const [existingPhotos, setExistingPhotos] = useState([]); // Store existing images
  const [showAddModal, setShowAddModal] = useState(false);
  const [showDetailModal, setShowDetailModal] = useState(false); // For detail modal
  const [showEditModal, setShowEditModal] = useState(false); // For edit modal
  const [selectedAlumnus, setSelectedAlumnus] = useState(null);
  const openAddModal = () => {
    setShowAddModal(true); // Open Add Alumni modal
    reset(); // Reset all form fields to empty
    setPhotos([]); // Clear new photos state
    setExistingPhotos([]); // Clear any pre-existing photos state
  };

  const closeAddModal = () => {
    setShowAddModal(false); // Close Add Alumni modal
    reset(); // Reset all form fields when closing
    setPhotos([]); // Clear new photos
    setExistingPhotos([]); // Clear existing photos
  };

  const onSubmit = async (data) => {
    const formData = new FormData();
    formData.append("name", data.name);
    formData.append("batch", data.batch);
    formData.append("achievement", data.achievement);
    formData.append("description", data.description);

    photos.forEach(({ file }) => {
      formData.append("photos", file);
    });

    // Otherwise, it's a new alumnus
    try {
      await dispatch(addAlumni(formData));
      toast.success("Alumni added successfully");
      setShowAddModal(false);

      // Reset form and clear images after adding
      reset();
      setPhotos([]);
      setExistingPhotos([]);
      dispatch(getAlumniData());
    } catch (err) {
      console.error(err);
      toast.error("Failed to add alumni");
    }
  };

  const handleShowDetail = (alumnus) => {
    setSelectedAlumnus(alumnus);
    setShowDetailModal(true); // Open the detail modal
  };

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    const filePreviews = files.map((file) => ({
      file,
      preview: URL.createObjectURL(file),
    }));
    setPhotos(filePreviews);
  };

  const deletePhoto = (index) => {
    setPhotos((prevPhotos) => prevPhotos.filter((_, i) => i !== index));
  };

  useEffect(() => {
    dispatch(getAlumniData());
  }, [dispatch]);

  useEffect(() => {
    return () => {
      photos.forEach(({ preview }) => URL.revokeObjectURL(preview));
    };
  }, [photos]);

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this alumni?")) return;
    try {
      await dispatch(deleteAlumniData(id));
      toast.success("Alumni deleted successfully");
      dispatch(getAlumniData());
    } catch (err) {
      console.error(err);
      toast.error("Failed to delete alumni");
    }
  };

  const handleEdit = (alumnus) => {
    setSelectedAlumnus(alumnus);
    setShowEditModal(true);

    // Set form values for editing
    setValue("name", alumnus.name);
    setValue("batch", alumnus.batch);
    setValue("achievement", alumnus.achievement);
    setValue("description", alumnus.description);

    // Set existing photos
    setExistingPhotos(alumnus.photos || []);
  };

  const onEditSubmit = async (data) => {
    const formData = new FormData();
    formData.append("name", data.name);
    formData.append("batch", data.batch);
    formData.append("achievement", data.achievement);
    formData.append("description", data.description);

    photos.forEach(({ file }) => {
      formData.append("photos", file);
    });

    // If we are editing an alumnus, update the data
    if (selectedAlumnus) {
      try {
        await dispatch(updateAlumniData(selectedAlumnus._id, formData));
        toast.success("Alumni updated successfully");
        setShowEditModal(false);
        dispatch(getAlumniData());
        reset();
        setPhotos([]);
        setExistingPhotos([]);
      } catch (err) {
        console.error(err);
        toast.error("Failed to update alumni");
      }
    }
  };
  const route = process.env.NEXT_PUBLIC_BASE_URL;

  return (
    <div className="flex flex-col md:flex-row md:items-center bg-gray-100 min-h-screen">
      <div className="lg:w-1/4 bg-white shadow-md">
        <AdminNavbar />
      </div>
      <Toaster position="top-right" richColors />
      <div className="flex-1 mr-12 w-full p-6 md:flex-row">
        <div className="flex flex-col items-center justify-center pb-4 border-b-4 border-black">
          <h2 className="text-3xl font-semibold text-center mb-6">
            Alumni List
          </h2>
          <Button
            type="primary"
            onClick={openAddModal}
            className="items-center justify-center py-3 mb-8"
          >
            Add Alumni
          </Button>
        </div>
        <div className="w-full p-6 my-4 bg-white rounded-lg shadow-md">
          {/* Display Alumni List */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {alumniData?.map((data, index) => (
              <div
                key={index}
                className="bg-gray-200 shadow flex flex-col items-center cursor-pointer hover:scale-105 duration-500"
              >
                <div
                  onClick={() => handleShowDetail(data)}
                  className="flex flex-col items-center"
                >
                  <img
                    src={`${data.photos?.[0]}`}
                    alt={data.name}
                    className="w-full h-52 mb-5 object-cover"
                  />
                  {/* <p className="text-gray-600 text-center">
                    {data.achievement}
                  </p> */}
                </div>
                <div className=" w-full flex justify-between items-center py-2 px-3  ">
                  <Button
                    type="primary"
                    className="top-0 right-0 text-white py-2 px-2"
                    onClick={() => handleEdit(data)}
                  >
                    <FaRegEdit title="Edit" />
                  </Button>
                  <div className=" text-center">
                    <p className="text-lg font-semibold">{data.name}</p>
                    <p className="text-gray-600 ">Batch: {data.batch}</p>
                  </div>
                  <Button
                    type="primary"
                    className="top-0 right-0 text-white py-2 px-2"
                    onClick={() => handleDelete(data._id)}
                  >
                    <AiOutlineDelete title="Delete" />
                  </Button>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Show detail  */}
        {showDetailModal && selectedAlumnus && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
            <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-lg h-auto relative">
              <button
                onClick={() => setShowDetailModal(false)}
                className="absolute top-2 right-2 text-3xl text-gray-500 font-semibold hover:scale-105 duration-300 hover:text-gray-800"
                aria-label="Close"
              >
                &times;
              </button>
              <div className="flex flex-col justify-center items-center ">
                <h3 className="text-xl font-semibold text-center border-b-2 w-full border-black pb-2 mb-2">
                  Alumni Details
                </h3>
                <div className="mb-4 w-1/2">
                  {selectedAlumnus.photos?.map((photo, index) => (
                    <img
                      key={index}
                      src={`${photo}`}
                      alt={`Imageis on`}
                      className="w-full h-1/2 object-cover roundesd-md mt-2"
                    />
                  ))}
                </div>
                <div className="text-lg flex my-1">
                  <h4 className="font-semibold mr-2">Name:</h4>
                  <p>{selectedAlumnus.name}</p>
                </div>
                <div className="text-lg flex my-1">
                  <h4 className="font-semibold mr-2">Batch:</h4>
                  <p>{selectedAlumnus.batch}</p>
                </div>
                <div className="text-lg flex my-1">
                  <h4 className="font-semibold mr-2">Achievement:</h4>
                  <p>{selectedAlumnus.achievement}</p>
                </div>
                <div className="text-lg flex my-1">
                  <h4 className="font-semibold mr-2">Description:</h4>
                  <p>{selectedAlumnus.description}</p>
                </div>
              </div>
            </div>
          </div>
        )}

        {/*  Edit Alumni Modal */}
        {showEditModal && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
            <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-md relative">
              <button
                onClick={() => setShowEditModal(false)}
                className="absolute top-2 right-2 text-gray-500 hover:text-gray-800"
                aria-label="Close"
              >
                ✕
              </button>
              <h3 className="text-xl font-semibold text-center mb-4">
                Edit Alumni
              </h3>
              <form onSubmit={handleSubmit(onEditSubmit)}>
                <div className="space-y-4">
                  <div>
                    <label
                      htmlFor="name"
                      className="block text-sm font-medium text-gray-700"
                    >
                      Name
                    </label>
                    <input
                      id="name"
                      type="text"
                      {...register("name", { required: "Name is required" })}
                      className="mt-1 block w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-red-500"
                    />
                    {errors.name && (
                      <p className="text-red-500 text-sm">
                        {errors.name.message}
                      </p>
                    )}
                  </div>
                  <div>
                    <label
                      htmlFor="batch"
                      className="block text-sm font-medium text-gray-700"
                    >
                      Batch
                    </label>
                    <input
                      id="batch"
                      type="text"
                      {...register("batch", { required: "Batch is required" })}
                      className="mt-1 block w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-red-500"
                    />
                    {errors.batch && (
                      <p className="text-red-500 text-sm">
                        {errors.batch.message}
                      </p>
                    )}
                  </div>
                  <div>
                    <label
                      htmlFor="achievement"
                      className="block text-sm font-medium text-gray-700"
                    >
                      Achievement
                    </label>
                    <textarea
                      id="achievement"
                      {...register("achievement", {
                        required: "Achievement is required",
                      })}
                      className="mt-1 block w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-red-500"
                    />
                    {errors.achievement && (
                      <p className="text-red-500 text-sm">
                        {errors.achievement.message}
                      </p>
                    )}
                  </div>
                  <div>
                    <label
                      htmlFor="description"
                      className="block text-sm font-medium text-gray-700"
                    >
                      Description
                    </label>
                    <textarea
                      id="description"
                      {...register("description", {
                        required: "Description is required",
                      })}
                      className="mt-1 block w-full h-32 p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-red-500"
                    />
                    {errors.description && (
                      <p className="text-red-500 text-sm">
                        {errors.description.message}
                      </p>
                    )}
                  </div>
                  <div>
                    <label
                      htmlFor="photos"
                      className="block text-sm font-medium text-gray-700"
                    >
                      Photos
                    </label>
                    <input
                      id="photos"
                      type="file"
                      accept="image/*"
                      multiple
                      onChange={handleFileChange}
                      className="mt-1 block w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-red-500"
                    />
                    {photos.length > 0 && (
                      <div className="flex space-x-2 mt-2">
                        {photos.map((photo, index) => (
                          <div key={index} className="relative">
                            <img
                              src={photo.preview}
                              alt="Preview"
                              className="w-16 h-16 object-cover rounded-md"
                            />
                            <button
                              type="button"
                              onClick={() => deletePhoto(index)}
                              className="absolute top-0 right-0 bg-red-600 text-white rounded-full p-1"
                            >
                              &times;
                            </button>
                          </div>
                        ))}
                      </div>
                    )}

                    {/* Show existing images for editing */}
                    {existingPhotos.length > 0 && (
                      <div className="flex space-x-2 mt-2">
                        {existingPhotos.map((photo, index) => (
                          <div key={index} className="relative">
                            <img
                              src={`${route}${photo}`}
                              alt="Existing"
                              className="w-16 h-16 object-cover rounded-md"
                            />
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                  <div className="mt-4">
                    <button
                      type="submit"
                      className="w-full py-2 bg-[#1e81b0] text-white rounded-md hover:bg-[#1384ba]"
                    >
                      {showAddModal ? "Add Alumni" : "Update Alumni"}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        )}

        {/* Add Alumni Modal */}
        {showAddModal && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
            <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-md relative">
              <button
                onClick={closeAddModal} // Trigger closing the Add Alumni modal
                className="absolute top-2 right-2 text-gray-500 hover:text-gray-800"
                aria-label="Close"
              >
                ✕
              </button>
              <h3 className="text-xl font-semibold text-center mb-4">
                Add Alumni
              </h3>
              <form onSubmit={handleSubmit(onSubmit)}>
                <div className="space-y-4">
                  <div>
                    <label
                      htmlFor="name"
                      className="block text-sm font-medium text-gray-700"
                    >
                      Name
                    </label>
                    <input
                      id="name"
                      type="text"
                      {...register("name", { required: "Name is required" })}
                      className="mt-1 block w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-red-500"
                    />
                    {errors.name && (
                      <p className="text-red-500 text-sm">
                        {errors.name.message}
                      </p>
                    )}
                  </div>

                  <div>
                    <label
                      htmlFor="batch"
                      className="block text-sm font-medium text-gray-700"
                    >
                      Batch
                    </label>
                    <input
                      id="batch"
                      type="text"
                      {...register("batch", { required: "Batch is required" })}
                      className="mt-1 block w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-red-500"
                    />
                    {errors.batch && (
                      <p className="text-red-500 text-sm">
                        {errors.batch.message}
                      </p>
                    )}
                  </div>

                  <div>
                    <label
                      htmlFor="achievement"
                      className="block text-sm font-medium text-gray-700"
                    >
                      Achievement
                    </label>
                    <textarea
                      id="achievement"
                      {...register("achievement", {
                        required: "Achievement is required",
                      })}
                      className="mt-1 block w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-red-500"
                    />
                    {errors.achievement && (
                      <p className="text-red-500 text-sm">
                        {errors.achievement.message}
                      </p>
                    )}
                  </div>

                  <div>
                    <label
                      htmlFor="description"
                      className="block text-sm font-medium text-gray-700"
                    >
                      Description
                    </label>
                    <textarea
                      id="description"
                      {...register("description", {
                        required: "Description is required",
                      })}
                      className="mt-1 block w-full h-32 p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-red-500"
                    />
                    {errors.description && (
                      <p className="text-red-500 text-sm">
                        {errors.description.message}
                      </p>
                    )}
                  </div>

                  <div>
                    <label
                      htmlFor="photos"
                      className="block text-sm font-medium text-gray-700"
                    >
                      Photos
                    </label>
                    <input
                      id="photos"
                      type="file"
                      accept="image/*"
                      multiple
                      onChange={handleFileChange}
                      className="mt-1 block w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-red-500"
                    />
                    {photos.length > 0 && (
                      <div className="flex space-x-2 mt-2">
                        {photos.map((photo, index) => (
                          <div key={index} className="relative">
                            <img
                              src={photo.preview}
                              alt="Preview"
                              className="w-16 h-16 object-cover rounded-md"
                            />
                            <button
                              type="button"
                              onClick={() => deletePhoto(index)}
                              className="absolute top-0 right-0 bg-red-600 text-white rounded-full p-1"
                            >
                              &times;
                            </button>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>

                  <div className="mt-4">
                    <button
                      type="submit"
                      className="w-full py-2 bg-[#1e81b0] text-white rounded-md hover:bg-[#1384ba] focus:ring-4 focus:ring-[#1e81b0]"
                    >
                      Add Alumni
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Alumni;
